import {Component, HostBinding, Input, OnInit} from '@angular/core';
import {LaboratoryDocument} from '@models/laboratory-document';
import {DocumentApiService} from '../../services/document.api.service';
import {LaboratoryDocumentsProvider} from '@providers/laboratory-documents/laboratory-documents.provider';
import {AuthService} from '@services/auth.service';
import {UserNamespace} from '@namespaces/user.namespace';
import {EventsService} from '@services/events.service';
import {PreviewModalService} from '@services/preview-modal.service';
import {NotyMessagesEnum} from '@helpers/noty-messages.enum';

@Component({
    selector: 'app-laboratory-document-view',
    templateUrl: 'document-view.component.html',
    styleUrls: ['document-view.component.scss']
})

export class DocumentViewComponent implements OnInit {
    @Input() document: LaboratoryDocument;

    /**
     * Куда добавляем документы?
     * В Организацию? В Лабораторию? Добавляем все документы?
     */
    @Input() target: 'all' | 'lab' | 'org' = 'all';

    @HostBinding('class') private className = 'hover-container';

    canEdit = false;
    canRemove = false;

    constructor(
        private apiService: DocumentApiService,
        private documentsProvider: LaboratoryDocumentsProvider,
        private authService: AuthService,
        private events: EventsService,
        private filesPreviewService: PreviewModalService,
    ) {

    }

    ngOnInit(): void {
        this.canEdit = this.authService.hasPermissions([UserNamespace.Permission.structureUnitDocumentUpdate]);
        this.canRemove = this.authService.hasPermissions([UserNamespace.Permission.structureUnitDocumentRemove]);
    }

    showFilePreview() {
        this.filesPreviewService.show({
            files: this.document.filesUrls
        });
    }

    remove() {
        this.events.showConfirm({
            title: 'Вы уверены, что хотите удалить документ?',
            confirmButtonTitle: 'Удалить',
        }).subscribe(() => {
            this.apiService.delete({
                id: this.document.rawData.id
            }).subscribe(() => {
                this.documentsProvider.updateData();
                this.events.showNoty({
                    type: 'success',
                    content: NotyMessagesEnum.laboratoryDocumentRemoved
                });
            }, () => {
                this.events.showNoty({
                    type: 'error',
                    content: NotyMessagesEnum.laboratoryDocumentRemovedFail
                });
            });
        }, () => {});
    }
}
